import React from "react";
import { Box } from "@mui/material";
import TimesheetManagerReviewTable from "../../components/Table/TimesheetManagerReviewTable";
import { useTimesheetManagerReviewViewModel } from "./TimesheetManagerReviewViewModel";
import Modal from "../../components/Modal/Modal";

const TimesheetManagerReview = () => {
  const {
    timesheetEntries,
    projects,
    resources,
    fridays,
    selectedFriday,
    handleFridayChange,
    handleReject,
    handleApprove,
    successModal,
    setSuccessModal,
    selectedProject,
    selectedResource,
    handleProjectChange,
    handleResourceChange,
    handleCommentSave,
    onError,
    isResourceRole,
  } = useTimesheetManagerReviewViewModel();

  return (
    <Box sx={{ p: 0 }}>
      <TimesheetManagerReviewTable
        data={timesheetEntries}
        projects={projects}
        resources={resources}
        selectedProject={selectedProject}
        selectedResource={selectedResource}
        onProjectChange={handleProjectChange}
        onResourceChange={handleResourceChange}
        fridays={fridays}
        selectedFriday={selectedFriday}
        onFridayChange={handleFridayChange}
        onReject={handleReject}
        onCommentSave={handleCommentSave}
        onApprove={handleApprove}
        onError={onError}
        isResourceRole={isResourceRole}
      />

      {successModal && (
        <Modal
          type={successModal.type}
          title={successModal.title}
          message={successModal.message}
          onClose={() => setSuccessModal(null)}
        />
      )}
    </Box>
  );
};

export default TimesheetManagerReview;
